// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.__adminManagement{
  display: grid;
  grid-template-columns: 280px 1fr;
  font-size: 1.8rem;
  height: 100%;
  margin-top: 5px;
  gap: 12px;
}
@media (min-height: 768px) {
  .__adminManagement{
    display: grid;
    grid-template-columns: 280px 1fr;
    font-size: 1.8rem;
    height: fit-content;
    margin-top: 5px;
    gap: 12px;
  }
}
.__adminManagement__filters{
  box-shadow: 0px 4.8px 14.4px rgba(0, 0, 0, 0.18);
  border-radius: 4px;
  text-align: left;
  background: #ffffff;
  height: fit-content;
  padding-bottom: 8px;
}
.__adminManagement__grid{
  box-shadow: 0px 4.8px 14.4px rgba(0, 0, 0, 0.18);
  border-radius: 4px;
  text-align: left;
  background: #ffffff;
  height: fit-content;
  overflow-x: auto;
  overflow-y: hidden;
  min-width: 0;
}
.__adminManagement__data {
  display: table;
  table-layout: fixed;
  width: 90%;
  background-color: Gray;
  margin-left: 1%;
}
.data__div.active {
  display: table-cell;
  height: 100px;
}
.data__div.active .MuiTableCell-root {
  border-bottom: none;
  background-color: transparent;
}
.data__div.active .MuiPaper-root {
  background-color: transparent;
}
.data__div.inactive {
  display: table-cell;
  height: 100px;
  background-color: rgb(234, 234, 234);
}
.__adminManagement_details{
  box-shadow: 0px 4.8px 14.4px rgba(0, 0, 0, 0.18);
  border-radius: 4px;
  text-align: left;
  background: #ffffff;
  height: fit-content;
}
.__adminManagement__grid--container{
  padding-bottom: 1px;
}
.__adminManagement__grid--container-title{
  font-weight: 600;
  font-size: 1.6rem;
  line-height: 20px;
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  color: #000;
  margin: 0;
  padding: 10px 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}
@media (min-height: 768px) {
  .__adminManagement__grid--container-title{
    font-weight: 600;
    font-size: var(--subheader);
    line-height: 20px;
    display: flex;
    align-items: center;
    color: #000;
    margin: 0;
    padding: 10px 12px;
  }
}
.__adminManagement__grid--container-freeAcion{
  display: flex;
  align-items: flex-end;
}
.__adminManagement__grid--container-dateRange{
  margin-right: 12px;
  font-size: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Modules/AdminManagement/searchTab/AdminSearch.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gCAAgC;EAChC,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,SAAS;AACX;AACA;EACE;IACE,aAAa;IACb,gCAAgC;IAChC,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,SAAS;EACX;AACF;AACA;EACE,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,UAAU;EACV,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,oCAAoC;AACtC;AACA;EACE,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,4CAA4C;AAC9C;AACA;EACE;IACE,gBAAgB;IAChB,2BAA2B;IAC3B,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,SAAS;IACT,kBAAkB;EACpB;AACF;AACA;EACE,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":[".__adminManagement{\n  display: grid;\n  grid-template-columns: 280px 1fr;\n  font-size: 1.8rem;\n  height: 100%;\n  margin-top: 5px;\n  gap: 12px;\n}\n@media (min-height: 768px) {\n  .__adminManagement{\n    display: grid;\n    grid-template-columns: 280px 1fr;\n    font-size: 1.8rem;\n    height: fit-content;\n    margin-top: 5px;\n    gap: 12px;\n  }\n}\n.__adminManagement__filters{\n  box-shadow: 0px 4.8px 14.4px rgba(0, 0, 0, 0.18);\n  border-radius: 4px;\n  text-align: left;\n  background: #ffffff;\n  height: fit-content;\n  padding-bottom: 8px;\n}\n.__adminManagement__grid{\n  box-shadow: 0px 4.8px 14.4px rgba(0, 0, 0, 0.18);\n  border-radius: 4px;\n  text-align: left;\n  background: #ffffff;\n  height: fit-content;\n  overflow-x: auto;\n  overflow-y: hidden;\n  min-width: 0;\n}\n.__adminManagement__data {\n  display: table;\n  table-layout: fixed;\n  width: 90%;\n  background-color: Gray;\n  margin-left: 1%;\n}\n.data__div.active {\n  display: table-cell;\n  height: 100px;\n}\n.data__div.active .MuiTableCell-root {\n  border-bottom: none;\n  background-color: transparent;\n}\n.data__div.active .MuiPaper-root {\n  background-color: transparent;\n}\n.data__div.inactive {\n  display: table-cell;\n  height: 100px;\n  background-color: rgb(234, 234, 234);\n}\n.__adminManagement_details{\n  box-shadow: 0px 4.8px 14.4px rgba(0, 0, 0, 0.18);\n  border-radius: 4px;\n  text-align: left;\n  background: #ffffff;\n  height: fit-content;\n}\n.__adminManagement__grid--container{\n  padding-bottom: 1px;\n}\n.__adminManagement__grid--container-title{\n  font-weight: 600;\n  font-size: 1.6rem;\n  line-height: 20px;\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  align-items: center;\n  color: #000;\n  margin: 0;\n  padding: 10px 12px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n}\n@media (min-height: 768px) {\n  .__adminManagement__grid--container-title{\n    font-weight: 600;\n    font-size: var(--subheader);\n    line-height: 20px;\n    display: flex;\n    align-items: center;\n    color: #000;\n    margin: 0;\n    padding: 10px 12px;\n  }\n}\n.__adminManagement__grid--container-freeAcion{\n  display: flex;\n  align-items: flex-end;\n}\n.__adminManagement__grid--container-dateRange{\n  margin-right: 12px;\n  font-size: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
